import type { MovieDto } from '@cineamo/api/models/movie/v2/MovieDto.types';

import { TMDB_IMAGE_RESOLUTION } from '@cineamo/api/constants/tmdb-constants';

import { getMovieBackdropImage, getMovieLogoImage, getMoviePosterImage } from '@cineamo/api/helpers/movie-helper';

import type { ScreenFilm } from '@cineamo/ui/src/room-3d/screen-film';

/** What the 3D screen shows for a film; `null` when it has no picture at all. */
export function screenFilmFromMovie(movie: MovieDto): ScreenFilm | null {
    const backdropUrl = getMovieBackdropImage(movie, {
        usePlaceholder: false,
        imageOptions: { resolution: TMDB_IMAGE_RESOLUTION.W780 }
    });
    const logoUrl = getMovieLogoImage(movie);
    const posterUrl = getMoviePosterImage(movie, {
        usePlaceholder: false,
        imageOptions: { resolution: TMDB_IMAGE_RESOLUTION.W342 }
    });
    if (!backdropUrl && !logoUrl && !posterUrl) return null;
    return { backdropUrl, logoUrl, posterUrl, title: movie.title ?? movie.originalTitle ?? String(movie.id) };
}
